import React from 'react';

import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  backgroundAndLogoContainer: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  giftCardContainer: {
    alignItems: 'flex-start',
    alignSelf: 'center',
    backgroundColor: primitive.$meltyYellow,
    borderRadius: 10,
    flexDirection: 'row',
    height: 190,
    marginVertical: spacing.$4,
    paddingLeft: spacing.$4,
    paddingTop: spacing.$4,
  },
  logoAndNameContainer: {
    flexDirection: 'column',
  },
});

export const GiftCardContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.giftCardContainer, style] });

export const LogoAndNameContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.logoAndNameContainer, style] });

export const BackgroundAndLogoContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.backgroundAndLogoContainer, style] });
